
/* eslint-disable */
import { useState, useCallback, useRef, useMemo, Fragment, useEffect } from 'react';
import ReactFlow, { BaseEdge, EdgeLabelRenderer, getBezierPath, ReactFlowProvider, useNodesState, useEdgesState, Background, Controls, Handle } from 'reactflow';

import { useParams, Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { Menu } from '@headlessui/react'
import { useQuery, useMutation } from '@tanstack/react-query';
import { useForm, Controller } from "react-hook-form";

import axios from 'axios';
import DatePicker from "react-datepicker";

import SideModal from './components/SideModal';
import Header from './components/Header';
import SearchBox from './components/SearchBox';
import AddNewButtonTemp from './components/ButtonWa';
import AddNewListTemp from './components/ListWa';
import CondComponet2 from './components/Condition';
import SelectOptions from './components/SelectOptions';
import EditButtonTemp from './components/EditWaButton';
import EditListTemp from './components/EditWaList';
import PreviewComp from './components/PreviewComp';
import ButtonImg from '../image/button-img.png';
import ListImg from '../image/list-img.png';
import Spinner from '../cutomComponent/spinner'
import Handles from '../cutomComponent/handles'
import SpreadsheetList from './testing.components';

import CustomRuleBox from './components/customRuleBox';
import WaitTillBox from './components/WaitTill';



import Keywords from './channelComp/Keywords';
import WebhookUrls from './channelComp/Webhooks';
import SmsBox from './channelComp/SmsBox';
import VoiceBox from './channelComp/VoiceBox';
import EmailBox from './channelComp/EmailBox';
import SaveFunnelBox from './channelComp/SaveFunnelBox';
import SavingForm from './channelComp/SavingForm';
import BoxHeader from './channelComp/BoxHeader';
import WaMessage from './channelComp/WaMessage';
import SetTagBox from './channelComp/SetTagBox';
import AllAtrribute from './channelComp/AllAtrribute';
import FunnelBox from './channelComp/FunnelBox';
import PhonebookBox from './channelComp/PhonebookBox';
import OnAtrribute from './channelComp/OnAtrribute';
import HeaderNav2 from './channelComp/HeaderNav2';
import AgentAssign from './channelComp/AgentAssign';

import useGlobalStore from '../store.js';



import { useTemp, useWaTemp, useEmp, useWaInter, useWebhook, useFunnel, useBsspTemp, useBsspSender, useUserDetail, useEmailSender, usePhonebookQuery } from '../api';



import 'reactflow/dist/style.css';
import 'react-toastify/dist/ReactToastify.css';

// let parsedUrl = new URL(window.location.href);
// const host = parsedUrl.protocol + '//' + parsedUrl.hostname + '/api';
// const bssp_host = 'https://sms.bulksmsserviceproviders.com/api/';
// const token = localStorage.getItem('token');
// const user_id = localStorage.getItem('user_id');
// const auth_key = localStorage.getItem('auth_key');
// const wa_authKey = localStorage.getItem('wa_auth_key');
// const bssp_authKey = "46a57c629565ac350bae4264c3e82d9e"
// const noAuth = () => {
//     localStorage.removeItem('token');
//     localStorage.removeItem('auth_key');
//     localStorage.removeItem('user_id');
//     localStorage.removeItem('username');
//     localStorage.removeItem('length');
//     localStorage.removeItem('wa_auth_key');
//     window.location.href = 'https://www.tickmaker.io/home';
// };
// const headers = {
//     "headers": {
//         'Authorization': `Bearer ${localStorage.getItem('token')}`,
//         'Access-Control-Allow-Origin': '*',
//         'Content-Type': 'application/json',
//         'Accept': "application/json",
//         'mode': 'no-cors',
//     }
// }

const defaultViewport: Viewport = { x: 0, y: 0, zoom: 0.7 };

export default function NewOne() {
    const { id } = useParams();

    const reactFlowWrapper = useRef(null);
    const [rfInstance, setRfInstance] = useState(null);
    const [nodes, setNodes, onNodesChange] = useNodesState([]);
    const [edges, setEdges, onEdgesChange] = useEdgesState([]);
    const [flowDetail, setFlowDetail] = useState([]);
    const [refecther, setRefecther] = useState(false);
    const [waPreview, setWaPreview] = useState([false, "", ""]);
    const [flowPreview, setFlowPreview] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState([false, ""]);

    const { noAuth, bssp_authKey, headers, wa_authKey, token, host } = useGlobalStore();
    
    const waEmployee = useEmp();
    const waInterQuery = useWaInter();
    const waTempQuery = useWaTemp();
    const webhookQuery = useWebhook();
    const funnelQuery = useFunnel();
    const bsspSender = useBsspSender();
    const bsspTemp = useBsspTemp();
    const userDetailQuery = useUserDetail();
    const emailSender = useEmailSender();
    const phonebookQuery = usePhonebookQuery();

    if (id) {
        const flowQuery = useQuery({
            queryKey: ['node', 'conn', 'details', id],
            queryFn: async () => {
                try {
                    const response = await axios.get(host + '/get_flow/' + id, headers);
                    setFlowDetail(response.data.flow_details)
                    setNodes(response.data.nodes)
                    setEdges(response.data.connection)
                    setRefecther(!refecther)
                    setValue('name', response.data.flow_details.flow_name);
                    setValue('phone_no_id', response.data.flow_details.wa_sender);
                    return response.data;
                } catch (error) {
                    throw error;
                }
            },
            refetchOnWindowFocus: false,
        })
    }


    const { register: flow, handleSubmit: FlowSubmit, control: FlowControl, setValue, setFocus, clearErrors, formState: { errors: flowErr } } = useForm()

    useEffect(() => {
        setValue('name', flowDetail.flow_name);
        setFocus('name')
        setValue('phone_no_id', flowDetail.wa_sender);
        setFocus('phone_no_id')
    }, [setValue, setFocus]);

    const mutation = useMutation({
        mutationFn: (newTodo) => {
            console.log(newTodo)
            return axios.post(host + "/new_save_flow", newTodo, headers);
        },
        onMutate: () => {
            toast.info('Saving...', {autoClose: false});
        },
        onSuccess: (data) => {
            toast.dismiss();
            toast.success(`Success: ${data.data.message}`);
            setTimeout(() => {
                window.location.href = `/new/${data.data.flow_id}`
            }, 3000);
        },
        onError: (error) => {
            toast.dismiss();
            toast.error(`Error: ${error.message}`);
        },
    });
    if (!token) noAuth()
    const onDelNode = (nodeId) => {
        let t = []
        const getRecursiveChildren = (id, allNodes) => {
            let chiled = [];
            allNodes.map((x, i) => {
                if (x.data.value.parent == id) {
                    chiled.push(x.id)
                    chiled.push(...getRecursiveChildren(x.id, allNodes))
                }
            });
            return chiled;
        }

        function nodeFun(nds) {
            nds.map((el) => {
                if (el.id == nodeId) {
                    t.push(el.id)
                    if (id) {
                        console.log(id, t)
                        axios.post(host + "/node_del", { "flow_id": id, "nodes": [el.id] }, headers)
                            .then(response => {
                                if (response.data.status == 200) {
                                    console.log(response.data)
                                    toast.success(response.data.message)
                                }
                            })
                            .catch(error => {
                                if (error.response) {
                                    if (error.response.status === 403) {
                                        Object.values(error.response.data.message).map(val => {
                                            val.map(i => {
                                                toast.error(i)
                                                console.log(i)
                                            })
                                        })
                                    }
                                }
                            })
                    }
                }
            });
        }

        setNodes(nds => {
            nodeFun(nds)
            const allNew = nds.filter(node => !t.includes(node.id))
            return allNew
        })
        setEdges(eds => eds.filter(edge => !(t.includes(edge.source) || t.includes(edge.target))))
        setRefecther(!refecther)
        setShowConfirmation([false, ""])
    }

    const onDelConn = (connId) => {
        function connFun(connId, target, source, sourceHandle) {
            axios.post(host + "/conn_del", {
                "flow_id": id,
                "connId": connId,
                "target": target,
                "source": source,
                "sourceHandle": sourceHandle
            }, headers)
                .then(response => {
                    if (response.data.status == 200) {
                        console.log(response.data)
                        toast.success(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 403) {
                            Object.values(error.response.data.message).map(val => {
                                val.map(i => {
                                    toast.error(i)
                                    console.log(i)
                                })
                            })
                        }
                    }
                })
        }

        setEdges(eds => {
            const allEdge = eds.filter(edge => {
                if (edge.id === connId) {
                    console.log(edge)
                    connFun(connId, edge.target, edge.source, edge.sourceHandle)
                } else {
                    return edge
                }
            })
            return allEdge
        })

        setRefecther(!refecther)
        setShowConfirmation([false, ""])
    }


    const CustomNode = (event) => {
        const id = event.id;
        const type = event.data.value.type

        if (type == "on_message") {
            return (
                <BoxHeader
                    event={event}
                    isSideHandle="true"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="all"
                    onConnect={onConnect}
                    typo="start_btn"
                    modelType="none"
                    setNodes={setNodes}
                >
                    <Keywords setNodes={setNodes} apisData={event.data.value.api} id={id} />
                </BoxHeader>
            )
        }

        else if (type == "on_webhook") {
            return (
                <BoxHeader
                    event={event}
                    isSideHandle="true"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="all"
                    onConnect={onConnect}
                    typo="start_btn"
                    modelType="none"
                    setNodes={setNodes}
                >
                    <WebhookUrls setNodes={setNodes} apisData={event.data.value.api} id={id} webhookQuery={webhookQuery} />
                </BoxHeader>
            )
        }

        else if (type == "whatsapp" || type == "pre_whatsapp" || type == "edit_whatsapp") {
            return <WADesign datas={event} typo={type} />
        }

        else if (type == "on_spreedsheet") {
            return (
                <BoxHeader
                    event={event}
                    isSideHandle="true"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="all"
                    onConnect={onConnect}
                    typo="start_btn"
                    modelType="none"
                    setNodes={setNodes}
                >
                    <SpreadsheetList setNodes={setNodes} id={id} />
                </BoxHeader>
            )
        }

        else if (type == "google_sheet") {
            return (
                <BoxHeader
                    event={event}
                    isSideHandle="true"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="all"
                    onConnect={onConnect}
                    typo="start_btn"
                    modelType="none"
                    setNodes={setNodes}
                >
                    <SpreadsheetList setNodes={setNodes} id={id} />
                </BoxHeader>
            )
        }

        else if (type == "wa_message") {
            return (
                <BoxHeader
                    event={event}
                    isSideHandle="true"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="wa_message_reply"
                    onConnect={onConnect}
                    typo="start_btn"
                    modelType="normal"
                    setNodes={setNodes}
                >
                    <WaMessage setNodes={setNodes} event={event} wa_authKey={wa_authKey} setRefecther={setRefecther} refecther={refecther} />
                </BoxHeader>
            )
        }

        else if (type == "on_new_funnel" || type == "on_funnel" || type == "on_edit_funnel") {
            return (
                <BoxHeader
                    event={event}
                    isSideHandle="true"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="all"
                    onConnect={onConnect}
                    typo="start_btn"
                    modelType="none"
                    setNodes={setNodes}
                >
                    <FunnelBox setNodes={setNodes} event={event} wa_authKey={wa_authKey} setRefecther={setRefecther} refecther={refecther} funnelQuery={funnelQuery} />
                </BoxHeader>
            )
        }

        else if (type == "phonebook") {
            return (
                <BoxHeader
                    event={event}
                    isSideHandle="true"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="all"
                    onConnect={onConnect}
                    typo="start_btn"
                    modelType="none"
                    setNodes={setNodes}
                >
                    <PhonebookBox setNodes={setNodes} event={event} wa_authKey={wa_authKey} setRefecther={setRefecther} refecther={refecther} phonebookQuery={phonebookQuery} />

                </BoxHeader>
            )
        }

        else if (type == "save_funnel") {
            return (
                <BoxHeader
                    event={event}
                    isSideHandle="true"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="all"
                    onConnect={onConnect}
                    typo="start_btn"
                    modelType="none"
                    setNodes={setNodes}
                >
                    <SaveFunnelBox setNodes={setNodes} apisData={event.data.value.api} id={id} eventData={event.data} funnelQuery={funnelQuery.data} />
                </BoxHeader>
            )
        }

        else if (type == "sms") {
            return (
                <BoxHeader
                    event={event}
                    isSideHandle="false"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="all" onConnect={onConnect}
                    typo="start_btn"
                    modelType="normal"
                    setNodes={setNodes}
                >
                    <SmsBox setNodes={setNodes} apisData={event.data.value.api} id={id} bsspSender={bsspSender} bsspTemp={bsspTemp} eventData={event.data} />
                </BoxHeader>
            )
        }

        else if (type == "voice") {
            return (
                <BoxHeader
                    event={event}
                    isSideHandle="false"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="all"
                    onConnect={onConnect}
                    typo="start_btn"
                    modelType="normal"
                    setNodes={setNodes}
                >
                    <VoiceBox setNodes={setNodes} apisData={event.data.value.api} id={id} bsspSender={bsspSender} bsspTemp={bsspTemp} eventData={event.data} />
                </BoxHeader>
            )
        }

        else if (type == "mail") {
            return (
                <BoxHeader
                    event={event}
                    isSideHandle="false"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="all"
                    onConnect={onConnect}
                    typo="start_btn"
                    modelType="normal"
                    setNodes={setNodes}
                >
                    <EmailBox setNodes={setNodes} apisData={event.data.value.api} id={id} emailSender={emailSender} eventData={event.data} />
                </BoxHeader>
            )
        }



        else if (type == "set_tag") {
            return (
                <BoxHeader
                    event={event}
                    isSideHandle="true"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="all"
                    onConnect={onConnect}
                    typo="start_btn"
                    modelType="none"
                    setNodes={setNodes}
                >
                    <SetTagBox setNodes={setNodes} event={event} wa_authKey={wa_authKey} waEmployee={waEmployee} />
                </BoxHeader>
            )
        }



        else if (type == "agent_assign") {

            return (
                <BoxHeader
                    event={event}
                    isSideHandle="true"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="all"
                    onConnect={onConnect}
                    typo="start_btn"
                    modelType="none"
                    setNodes={setNodes}
                >
                    <AgentAssign
                        apiDetail={event.data.value.api}
                        waEmployee={waEmployee}
                        setNodes={setNodes}
                        id={id}
                        wa_authKey={wa_authKey}
                        setRefecther={setRefecther}
                    />
                </BoxHeader>
            )
        }



        else if (type == "on_attribute") {
            return (
                <BoxHeader
                    event={event}
                    isSideHandle="true"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="all"
                    onConnect={onConnect}
                    typo="start_btn"
                    modelType="none"
                    setNodes={setNodes}
                >
                    <OnAtrribute setNodes={setNodes} event={event} wa_authKey={wa_authKey} />
                </BoxHeader>
            )
        }

        else if (type == "all_attrtibute") {
            return (
                <BoxHeader
                    event={event}
                    isSideHandle="true"
                    items_ul2={items_ul2}
                    setShowConfirmation={setShowConfirmation}
                    cond="all"
                    onConnect={onConnect}
                    typo="start_btn"
                    modelType="none"
                    setNodes={setNodes}
                >
                    <AllAtrribute setNodes={setNodes} event={event} wa_authKey={wa_authKey} waEmployee={waEmployee} />
                </BoxHeader>
            )
        }
    }

    const WADesign = ({ datas }) => {
        let searchTerm = /{{\d+}}/g;
        const [load, setLoad] = useState(false)
        if (datas.data.value.type == "whatsapp") {
            const item = datas.data.value.extra

            if (item && item != "") {
                if (datas.data.value.api.whatsapp_type == "interactive") {
                    const HeaderView = ({ headData }) => {
                        const { register: headerRes, handleSubmit: headerSub } = useForm({});
                        const [rerender, setRerender] = useState(false);
                        let matches = headData.match(searchTerm);
                        let vars = JSON.parse(datas.data.value.api.whatsapp_var) // Decoded
                        const varSet = (index, val) => {
                            let t = {}
                            t[`${index}`] = { "col": `col-${val}`, "type": "text" }
                            if (vars && vars != {}) {
                                if (vars.header && vars.header != {}) {
                                    datas.data.value.api.whatsapp_var = JSON.stringify({ ...vars, ...{ "header": { ...vars.header, ...t } } })
                                } else {
                                    datas.data.value.api.whatsapp_var = JSON.stringify({ ...vars, ...{ header: t } })
                                }
                            } else {
                                datas.data.value.api.whatsapp_var = JSON.stringify({ header: t })
                            }
                            setRerender(!rerender)
                        }

                        return (
                            <Fragment>
                                <p>{headData}</p>
                                {matches && matches.length > 0 ? (
                                    <Fragment>
                                        <label className="header_heading m-0">
                                            <i className="fa-solid fa-file-lines"></i> Header Variables
                                        </label>
                                        {
                                            matches.map((varValue, key) => (
                                                <select
                                                    value={vars.header && vars.header[`index${key}`] ? vars.header[`index${key}`]['col'].split("-")[1] : ""}
                                                    className="form-select form-select-sm" {...headerRes(`col_${varValue}`)}
                                                    onChange={(e) => varSet(`index${key}`, e.target.value)} key={key}
                                                >
                                                    <option value="" disabled>Select Variable {key + 1}</option>
                                                    <SelectOptions colObj={datas.data.value.columns} />
                                                </select>
                                            ))
                                        }
                                    </Fragment>
                                ) : (<p></p>)}
                            </Fragment>
                        );
                    }

                    const BodyView = ({ BodyData }) => {
                        const { register: bodyRes, control: bodyControl, handleSubmit: bodyHandle } = useForm({});
                        const [rerender, setRerender] = useState(false);
                        let matches = BodyData.match(searchTerm);
                        let vars = JSON.parse(datas.data.value.api.whatsapp_var) // Decoded

                        const varSet = (index, val) => {
                            let t = {}
                            t[`${index}`] = { "col": `col-${val}`, "type": "text" }
                            if (vars && vars != {}) {
                                if (vars.body && vars.body != {}) {
                                    datas.data.value.api.whatsapp_var = JSON.stringify({ ...vars, ...{ "body": { ...vars.body, ...t } } })
                                } else {
                                    datas.data.value.api.whatsapp_var = JSON.stringify({ ...vars, ...{ body: t } })
                                }
                            } else {
                                datas.data.value.api.whatsapp_var = JSON.stringify({ body: t })
                            }

                            setRerender(!rerender)
                        }

                        return (
                            <div className="body_teml mt-1 mb-1">
                                <label className="header_heading"> <i className="fa-solid fa-file-lines"></i> Body</label>
                                <div className="body_enter_text_box">
                                    <p>{BodyData}</p>
                                    {matches && matches.length > 0 ? (
                                        <Fragment>
                                            <label className="header_heading m-0">
                                                <i className="fa-solid fa-file-lines"></i> Body Variables
                                            </label>
                                            {
                                                matches.map((varValue, key) => (
                                                    <Fragment key={key}>
                                                        <select
                                                            value={vars.body && vars.body[`index${key}`] ? vars.body[`index${key}`]['col'].split("-")[1] : ""}
                                                            className="form-select form-select-sm" {...bodyRes(`col_${varValue}`)}
                                                            onChange={(e) => varSet(`index${key}`, e.target.value)}
                                                        >
                                                            <option value="" disabled>Select Variable {key + 1}</option>
                                                            <SelectOptions colObj={datas.data.value.columns} />
                                                        </select>
                                                    </Fragment>
                                                ))
                                            }
                                        </Fragment>
                                    ) : (<p></p>)}
                                </div>
                            </div>
                        );

                    }

                    const HeaderFunc = ({ i }) => {
                        if (i.header_data != "" && i.header_data != null) {
                            if (i.header_type == "text") {
                                return (
                                    <div className="header_teml">
                                        <label className="header_heading"> <i className="fa-solid fa-tachograph-digital"></i> Header</label>
                                        <div className="header_enter_text_box">
                                            <HeaderView headData={i.header_data} />
                                        </div>
                                    </div>
                                )
                            } else if (i.header_type == "image") {
                                return (
                                    <div className="header_teml">
                                        <label className="header_heading"> <i className="fa-solid fa-tachograph-digital"></i> Header</label>
                                        <div className="header_enter_text_box">
                                            <div className="img-fluid">  <img src={i.header_data} alt="WA Header Image" /> </div>
                                        </div>
                                    </div>
                                )
                            }
                        }
                    }

                    const FooterFunc = ({ i }) => {
                        if (i.footer != "" && i.footer != null) {
                            return (
                                <div className="footer_teml mt-2">
                                    <label className="header_heading"> <i className="fa-solid fa-table-list"></i> Footer</label>
                                    <div className="footer_enter_text_box">
                                        <p>{i.footer}</p>
                                    </div>
                                </div>
                            )
                        }
                    }

                    const ButtonFunc = ({ i }) => {
                        const main_arr = JSON.parse(datas.data.value.api.interactive_btn)
                        if (!main_arr || main_arr == null) {
                            console.log(datas.data.value)
                            return;
                        }
                        if (datas.data.value.api.interactive_type == "list") {


                            const groupedBySection = main_arr.reduce((acc, item) => {
                                if (acc[item.section_no]) {
                                    acc[item.section_no].rows.push(item);
                                } else {
                                    acc[item.section_no] = {
                                        section_no: item.section_no,
                                        section_title: item.section_title,
                                        rows: [item]
                                    };
                                }
                                return acc;
                            }, {});

                            const resultArray = useMemo(() => Object.values(groupedBySection), [groupedBySection]);

                            const RowDetails = ({ newDatas }) => {
                                return (
                                    <Fragment>
                                        {
                                            newDatas.map((x, sec_ind) => {
                                                return (
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className='flex mb-2'>
                                                                <div className="Button_div_box ">
                                                                    <p> {x.row_title}</p>
                                                                </div>
                                                                <div className="downBtnPlus">
                                                                    <SideModal
                                                                        cond={x.row_title + " List(Button)"}
                                                                        id={`list_btn-${x.row_title}-${sec_ind}`}
                                                                        event={datas}
                                                                        items_ul2={items_ul2}
                                                                        typo="start_btn_new"
                                                                        modelType="none"
                                                                    />
                                                                    <Handle
                                                                        type="source" position="right" id={`list_btn-${x.row_title}-${sec_ind}`} className="right_main main_point"
                                                                        onConnect={(params) => onConnect({ ...params, "cond": x.row_title + " List(Button)", datas: datas })}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </Fragment>
                                )
                            }

                            return (
                                <Fragment>
                                    {
                                        resultArray.map((i) => {
                                            return (
                                                <Fragment>
                                                    <div className="d-flex justify-content-center">
                                                        <h6>{i.section_title}</h6>
                                                    </div>
                                                    <RowDetails newDatas={i.rows} />
                                                </Fragment>
                                            )
                                        })
                                    }
                                </Fragment>
                            )
                        }
                        else if (datas.data.value.api.interactive_type == "button") {
                            return main_arr.map((x, sec_ind) => {
                                return (
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className='flex mb-2'>
                                                <div className="Button_div_box ">
                                                    <p> {x.title}</p>
                                                </div>
                                                <div className="downBtnPlus">
                                                    <SideModal cond={x.title + " Button"} id={`button_btn-${x.title}-${sec_ind}`} event={datas} items_ul2={items_ul2} typo="start_btn_new" modelType="none" />
                                                    <Handle
                                                        type="source" position="right" className="right_main main_point" id={`button_btn-${x.title}-${sec_ind}`}
                                                        onConnect={(params) => onConnect({ ...params, "cond": x.title + " Button", "datas": datas })}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    }

                    const editingFun = (e, typo) => {
                        setNodes(nds => nds.map(node => {
                            if (node.id == datas.id) {
                                node.data.value.type = "edit_whatsapp"
                                node.data.value.api.ndsType = "edit"
                            }
                            return node;
                        }))
                        setLoad(!load)
                    }
                    return (
                        <>
                            <Handles type='target' parent={datas.data.value.parent} />
                            <div className="main_flex_div">
                                <div className="card position-relative p-0 box_width h-lg-100">
                                    <div className="card-header temp_bg">
                                        <div className="row">
                                            <div className="col-md-7">
                                                <h5 className="mt-2 font-weight-bold temp_text_color a4">
                                                    <i className="fa-solid fa-photo-film"> </i> {datas.data.label}
                                                </h5>
                                            </div>
                                            <div className="col-md-5 text-right">
                                                <button type="button" className="btn-sm btn-success" onClick={(e) => editingFun(e, "edit")}>
                                                    <i className="fa-solid fa-user-pen"></i>
                                                </button>
                                                <button type="button" className="btn-sm btn-danger" onClick={(e) => setShowConfirmation([true, datas.id])}>
                                                    <i className="fa-solid fa-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body mt-0">
                                        <HeaderFunc i={item} />

                                        <div className="body_teml mt-1 mb-1">
                                            <label className="header_heading"> <i className="fa-solid fa-file-lines"></i> Body</label>
                                            <div className="body_enter_text_box">
                                                <BodyView BodyData={item.body} />
                                            </div>
                                        </div>
                                        <FooterFunc i={item} />

                                        <div className="line_ashish"> </div>
                                        <div className="Button_teml">
                                            <ButtonFunc i={item} />
                                            <CustomRuleBox event={datas} items_ul2={items_ul2} onConnect={onConnect} setNodes={setNodes} />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className='start_btn_pos h-lg-100'>
                                    <SideModal cond={"wa_reply"} id={`Sourcehandle-${datas.id}`} event={datas} items_ul2={items_ul2} typo="start_btn" modelType="normal" />
                                </div> */}
                            </div>
                            {/* <Handle type="source" position="right" className="main_point" id={`Sourcehandle-${datas.id}`} /> */}
                        </>
                    )
                } else if (datas.data.value.api.whatsapp_type == "template") {

                    const HeaderView = ({ vals }) => {
                        const { register: headerRes, handleSubmit: headerSub } = useForm({});
                        let vars = JSON.parse(datas.data.value.api.whatsapp_var) // Decoded

                        const varSetHeader = (index, val, type) => {
                            let t = {}
                            t[`${index}`] = { "col": `col-${val}`, "type": type }

                            if (vars && vars != {}) {
                                if (vars.header && vars.header != {}) {
                                    datas.data.value.api.whatsapp_var = JSON.stringify({ "header": { ...vars.header, ...t } })
                                } else {
                                    datas.data.value.api.whatsapp_var = JSON.stringify({ ...vars, ...{ header: t } })
                                }
                            } else {
                                datas.data.value.api.whatsapp_var = JSON.stringify({ header: t })
                            }
                        }

                        const HeaderFun = () => {
                            if (vals.example && vals.example != {}) {
                                if (vals.example.header_text && vals.example.header_text.length != 0) {
                                    return (
                                        <Fragment>
                                            <label className="header_heading m-0">
                                                <i className="fa-solid fa-file-lines"></i> Header Variables
                                            </label>
                                            {
                                                vals.example.header_text.map((varValue, key) => (
                                                    <select
                                                        value={vars.header && vars.header[`index${key}`] ? vars.header[`index${key}`]['col'].split("-")[1] : ""}
                                                        className="form-select form-select-sm" {...headerRes(`col_${varValue}`)} key={key}
                                                        onChange={(e) => varSetHeader(`index${key}`, e.target.value, "text")}
                                                    >
                                                        <option value="" disabled>Select Variable {key + 1}</option>
                                                        <SelectOptions colObj={datas.data.value.columns} />
                                                    </select>
                                                ))
                                            }
                                        </Fragment>
                                    )
                                }
                                else if (vals.example.header_handle && vals.example.header_handle.length != 0) {
                                    return (
                                        <Fragment>
                                            <label className="header_heading m-0">
                                                <i className="fa-solid fa-file-lines"></i> Header Variables
                                            </label>
                                            {
                                                vals.example.header_handle.map((varValue, key) => (
                                                    <select
                                                        value={vars.header && vars.header[`index${key}`] ? vars.header[`index${key}`]['col'].split("-")[1] : ""}
                                                        className="form-select form-select-sm" {...headerRes(`col_${varValue}`)} key={key}
                                                        onChange={(e) => varSetHeader(`index${key}`, e.target.value, vals.format)}
                                                    >
                                                        <option value="" disabled>Select {vals.format} File</option>
                                                        <SelectOptions colObj={datas.data.value.columns} />
                                                    </select>

                                                ))
                                            }
                                        </Fragment>
                                    )
                                }
                            }
                        }
                        return <HeaderFun />
                    }

                    const BodyView = ({ vals }) => {
                        const { register: bodyRes, handleSubmit: headerSub } = useForm({});
                        let vars = JSON.parse(datas.data.value.api.whatsapp_var) // Decoded

                        const varSetBody = (index, val, type) => {
                            let t = {}
                            t[`${index}`] = { "col": `col-${val}`, "type": type }
                            console.log(t)
                            if (vars && vars != {}) {
                                if (vars.body && vars.body != {}) {
                                    console.log(1)
                                    datas.data.value.api.whatsapp_var = JSON.stringify({ "body": { ...vars.body, ...t } })
                                } else {
                                    console.log(2)

                                    datas.data.value.api.whatsapp_var = JSON.stringify({ ...vars, ...{ body: t } })
                                }
                            } else {
                                console.log(3)

                                datas.data.value.api.whatsapp_var = JSON.stringify({ body: t })
                            }


                            console.log(datas.data.value.api.whatsapp_var)
                        }


                        if (vals.example && vals.example != {}) {
                            if (vals.example.body_text && vals.example.body_text.length != 0) {
                                return (
                                    <Fragment>
                                        <label className="header_heading m-0">
                                            <i className="fa-solid fa-file-lines"></i> Body Variables
                                        </label>
                                        {
                                            vals.example.body_text[0].map((varValue, key) => (
                                                <Fragment key={key}>
                                                    <select
                                                        value={vars.body && vars.body[`index${key}`] ? vars.body[`index${key}`]['col'].split("-")[1] : ""}
                                                        className="form-select form-select-sm" {...bodyRes(`col_${varValue}`)}
                                                        onChange={(e) => varSetBody(`index${key}`, e.target.value, "text")}
                                                    >
                                                        <option value="" disabled>Select Variable {key + 1}</option>
                                                        <SelectOptions colObj={datas.data.value.columns} />
                                                    </select>
                                                </Fragment>
                                            ))
                                        }
                                    </Fragment>
                                )
                            }
                        }
                    }

                    const BtnView = ({ vals }) => {
                        const { register: btnRes, handleSubmit: headerSub } = useForm({});
                        let vars = JSON.parse(datas.data.value.api.whatsapp_var) // Decoded
                        const varSetBtn = (index, val, type) => {
                            let t = {}
                            t[`${index}`] = { "col": `col-${val}`, "type": type }
                            if (vars && vars != {}) {
                                if (vars.button && vars.button != {}) {
                                    datas.data.value.api.whatsapp_var = JSON.stringify({ "button": { ...vars.button, ...t } })
                                } else {
                                    datas.data.value.api.whatsapp_var = JSON.stringify({ ...vars, ...{ button: t } })
                                }
                            } else {
                                datas.data.value.api.whatsapp_var = JSON.stringify({ button: t })
                            }
                        }

                        const BtnFun = () => {
                            if (vals.type == "BUTTONS") {
                                return vals.buttons.map((btn_type, newKey) => {
                                    if (btn_type.type == "URL" && btn_type.example && btn_type.example.length != 0) {
                                        return btn_type.example.map((varValue) => {
                                            return (
                                                <Fragment key={newKey}>
                                                    <select
                                                        value={vars.button && vars.button[`index${newKey}`] ? vars.button[`index${newKey}`]['col'].split("-")[1] : ""}
                                                        className="form-select form-select-sm" {...btnRes(`col_${btn_type.text}`)}
                                                        onChange={(e) => varSetBtn(`index${newKey}`, e.target.value, btn_type.type)}
                                                    >
                                                        <option value="" disabled>Select Variable {newKey + 1}</option>
                                                        <SelectOptions colObj={datas.data.value.columns} />
                                                    </select>
                                                </Fragment>
                                            )
                                        })
                                    }
                                })
                            }
                        }
                        return (
                            <Fragment>
                                <label className="header_heading m-0">
                                    <i className="fa-solid fa-file-lines"></i> Button Variables
                                </label>
                                <BtnFun />
                            </Fragment>
                        );
                    }

                    const temp_button_fun = (vals) => {
                        if (vals.length == 0) {
                            return ""
                        }
                        return (
                            <Fragment>
                                <div className="line_ashish"> </div>
                                <div className="Button_teml">
                                    {vals.map((x, sec_ind) => {
                                        if (x.type == "QUICK_REPLY") {
                                            return (
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className='flex mb-2'>
                                                            <div className="Button_div_box ">
                                                                <p> {x.text} </p>
                                                            </div>
                                                            <div className="downBtnPlus">
                                                                <SideModal cond={x.text + " Button"} id={`temp_btn-${x.text}-${sec_ind}`} event={datas} items_ul2={items_ul2} typo="start_btn_new" modelType="none" />
                                                                <Handle
                                                                    type="source" position="right" className="right_main main_point" id={`temp_btn-${x.text}-${sec_ind}`}
                                                                    onConnect={(params) => onConnect({ ...params, "cond": x.text + " Button", "datas": datas })}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    })}
                                </div>
                            </Fragment>
                        )
                    }

                    const new_function = () => {
                        return JSON.parse(item.companents).map(value => {
                            if (value.type == "HEADER") {
                                if (value.format == "TEXT") {
                                    return (
                                        <Fragment>
                                            <div className="header_teml">
                                                <label className="header_heading"> <i className="fa-solid fa-tachograph-digital"></i> Header</label>
                                                <div className="header_enter_text_box">
                                                    <p> {value.text}</p>
                                                    <HeaderView vals={value} />
                                                </div>
                                            </div>
                                        </Fragment>
                                    )
                                } else if (value.format == "IMAGE") {
                                    return (
                                        <div className="header_teml">
                                            <label className="header_heading"> <i className="fa-solid fa-tachograph-digital"></i> Header</label>
                                            <div className="header_enter_text_box">
                                                <div className="img-fluid">   <img src={value.example.header_handle[0]} /> </div>
                                                <HeaderView vals={value} />
                                            </div>
                                        </div>
                                    )
                                } else if (value.format == "DOCUMENT") { }
                            } else if (value.type == "BODY") {
                                return (
                                    <div className="body_teml mt-1 mb-1">
                                        <label className="header_heading"> <i className="fa-solid fa-file-lines"></i> Body</label>
                                        <div className="body_enter_text_box">
                                            <p>{value.text}</p>
                                            <BodyView vals={value} />
                                        </div>
                                    </div>
                                )
                            } else if (value.type == "BUTTONS") {
                                return (
                                    <div>
                                        {temp_button_fun(value.buttons)}
                                        <BtnView vals={value} />
                                    </div>
                                )
                            }
                        })
                    }

                    return (
                        <Fragment>
                            <Handles type='target' parent={datas.data.value.parent} />
                            <div className="main_flex_div">
                                <div className="card position-relative p-0 box_width h-lg-100">
                                    <div className="card-header temp_bg">
                                        <div className="row">
                                            <div className="col-md-7">
                                                <h5 className="mt-2 font-weight-bold temp_text_color a1">
                                                    <i className="fa-regular fa-images"></i> {datas.data.label}
                                                </h5>
                                            </div>
                                            <div className="col-md-5 text-right">
                                                <button type="button" className="btn-sm btn-danger" onClick={(e) => setShowConfirmation([true, datas.id])}>
                                                    <i className="fa-solid fa-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body mt-0">{new_function()}</div>
                                </div>

                                <div className='start_btn_pos h-lg-100'>
                                    <SideModal cond={"wa_reply"} id={`Sourcehandle-${datas.id}`} event={datas} items_ul2={items_ul2} typo="start_btn" modelType="normal" />
                                </div>
                            </div>
                            <Handle
                                type="source" position="right" className="main_point" id={`Sourcehandle-${datas.id}`}
                                onConnect={(params) => onConnect({ ...params, "cond": "wa_reply", datas: datas })}
                            />
                        </Fragment>
                    )
                }
            }
        } else if (datas.data.value.type == "pre_whatsapp") {
            return <WAPreDesign datas={datas} setLoad={setLoad} load={load} />
        }
        else if (datas.data.value.type == "edit_whatsapp") {
            return <WAEditDesign datas={datas} setLoad={setLoad} load={load} />
        }
    }

    const WAEditDesign = ({ datas, setLoad, load }) => {
        const int_btn = datas.data.value.api.interactive_btn
        const showError = (msg) => {
            toast.error(msg);
        }
        if (datas.data.value.api.whatsapp_type == "interactive") {
            if (datas.data.value.api.interactive_type == "button") {
                return (
                    <Fragment>
                        <Handles type='target' parent={datas.data.value.parent} />
                        <div className="card position-relative p-0 box_width">
                            <div className="card-header temp_bg">
                                <div className="row">
                                    <div className="col-md-7">
                                        <h5 className="mt-2 font-weight-bold temp_text_color a2">
                                            <i className="fa-regular fa-address-card"></i> {datas.data.label}
                                        </h5>
                                    </div>
                                    <div className="col-md-5 text-right">
                                        <button onClick={(e) => setShowConfirmation([true, datas.id])} type="button" className="btn-sm btn-danger">
                                            <i className="fa-solid fa-trash"></i>
                                        </button>


                                        <button type="button" className="btn-sm btn-success" onClick={(e) => setWaPreview([true, "button", datas.id])}>
                                            <i className="fa-solid fa-eye"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body mt-0">
                                <EditButtonTemp
                                    setLoad={setLoad}
                                    load={load}
                                    nodeId={datas.id}
                                    datas={datas.data.value}
                                    showError={showError}
                                    setNodes={setNodes} />
                            </div>
                        </div>
                    </Fragment>
                )
            }

            else if (datas.data.value.api.interactive_type == "list") {
                return (
                    <Fragment>
                        <Handles type='target' parent={datas.data.value.parent} />
                        <div className="card position-relative p-0 box_width">
                            <div className="card-header temp_bg">
                                <div className="row">
                                    <div className="col-md-7">
                                        <h5 className="mt-2 font-weight-bold temp_text_color a3">
                                            <i className="fa-regular fa-rectangle-list"></i> {datas.data.label}
                                        </h5>
                                    </div>
                                    <div className="col-md-5 text-right">
                                        <button onClick={(e) => setShowConfirmation([true, datas.id])} type="button" className="btn-sm btn-danger">
                                            <i className="fa-solid fa-trash"></i>
                                        </button>
                                        <button type="button" className="btn-sm btn-success" onClick={(e) => setWaPreview([true, "button", datas.id])}>
                                            <i className="fa-solid fa-eye"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body mt-0">
                                <EditListTemp
                                    setNodes={setNodes}
                                    setEdges={setEdges}
                                    setLoad={setLoad}
                                    load={load}
                                    nodeId={datas.id}
                                    showError={showError}
                                    datas={datas.data.value}
                                />
                            </div>
                        </div>
                    </Fragment>
                )
            }

        }
    }

    const WAPreDesign = ({ datas, setLoad, load }) => {
        const saveFormData = (formData) => {
            setNodes(nds => nds.map(node => {
                if (node.id == formData.nodeId) {
                    const nodeVal = node.data.value
                    node.data.label = formData.template_name
                    nodeVal.type = "whatsapp"
                    let extras = {
                        "template_id": "",
                        "title": formData.template_name,
                        "int_type": "button",
                        "header_type": "text",
                        "header_data": formData.header,
                        "file_name": null,
                        "body": formData.body,
                        "footer": formData.footer,
                        "is_variable": "0"
                    }
                    nodeVal.api.interactive_btn = JSON.stringify(formData.button)
                    nodeVal.extra = extras
                }
                return node;
            }))
            setLoad(!load)
            setRefecther(!refecther)
        };

        const editBtnData = (formData) => {
            console.log(formData)
        }

        const saveListFormData = (formData) => {
            let listArr = [];
            formData.action.map((item, index) => {
                item.rows.map((rowEle, rowInd) => {
                    listArr.push({
                        "button_title": formData.btn_title,
                        "section_no": index + 1,
                        "section_title": item.title,
                        "row_no": rowInd + 1,
                        "row_id": "65d6e562d9bd9",
                        "row_title": rowEle.row_title,
                        "row_desc": rowEle.row_description
                    })
                })
            })
            setNodes(nds => nds.map(node => {
                if (node.id == formData.nodeId) {
                    const nodeVal = node.data.value
                    node.data.label = formData.template_name
                    nodeVal.type = "whatsapp"
                    let extras = {
                        "template_id": "",
                        "title": formData.template_name,
                        "int_type": "list",
                        "header_type": "text",
                        "header_data": formData.header,
                        "file_name": null,
                        "body": formData.body,
                        "footer": formData.footer,
                        "is_variable": "0"
                    }
                    nodeVal.api.interactive_btn = JSON.stringify(listArr)
                    nodeVal.api.intListData = JSON.stringify(formData.action)
                    nodeVal.api.intListTitle = formData.btn_title
                    nodeVal.extra = extras
                }
                return node;
            }))
            setLoad(!load)
            setRefecther(!refecther)
        }

        const showError = (msg) => {
            toast.error(msg);
        }


        if (datas.data.value.api.whatsapp_type == "interactive") {
            if (datas.data.value.api.interactive_type == "button") {
                if (datas.data.value.api.ndsType == "edit") {
                    return (
                        <Fragment>
                            <Handles type='target' parent={datas.data.value.parent} />
                            <div className="card position-relative p-0 box_width">
                                <div className="card-header temp_bg">
                                    <div className="row">
                                        <div className="col-md-7">
                                            <h5 className="mt-2 font-weight-bold temp_text_color a2">
                                                <i className="fa-regular fa-address-card"></i> {datas.data.label}
                                            </h5>
                                        </div>
                                        <div className="col-md-5 text-right">
                                            <button type="button" className="btn-sm btn-danger" onClick={(e) => setShowConfirmation([true, datas.id])}>
                                                <i className="fa-solid fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body mt-0">
                                    <AddNewButtonTemp
                                        setLoad={setLoad}
                                        load={load}
                                        onSave={editBtnData}
                                        nodeId={datas.id}
                                        datas={datas.data.value}
                                        showError={showError}
                                        setNodes={setNodes} />
                                </div>
                            </div>
                        </Fragment>
                    )
                } else if (datas.data.value.api.ndsType == "new") {
                    return (
                        <Fragment>
                            <Handles type='target' parent={datas.data.value.parent} />
                            <div className="card position-relative p-0 box_width">
                                <div className="card-header temp_bg">
                                    <div className="row">
                                        <div className="col-md-7">
                                            <h5 className="mt-2 font-weight-bold temp_text_color a2">
                                                <i className="fa-regular fa-address-card"></i> {datas.data.label}
                                            </h5>
                                        </div>
                                        <div className="col-md-5 text-right">
                                            <button type="button" className="btn-sm btn-danger" onClick={(e) => setShowConfirmation([true, datas.id])}>
                                                <i className="fa-solid fa-trash"></i>
                                            </button>
                                            <button type="button" className="btn-sm btn-success" onClick={(e) => setWaPreview([true, "button", datas.id])}>
                                                <i className="fa-solid fa-eye"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body mt-0">
                                    <AddNewButtonTemp
                                        setLoad={setLoad}
                                        load={load}
                                        onSave={saveFormData}
                                        nodeId={datas.id}
                                        datas={datas.data.value}
                                        showError={showError}
                                        setNodes={setNodes} />
                                </div>
                            </div>
                        </Fragment>
                    )
                }

            } else if (datas.data.value.api.interactive_type == "list") {
                return (
                    <Fragment>
                        <Handles type='target' parent={datas.data.value.parent} />
                        <div className="card position-relative p-0 box_width">
                            <div className="card-header temp_bg">
                                <div className="row">
                                    <div className="col-md-7">
                                        <h5 className="mt-2 font-weight-bold temp_text_color a3">
                                            <i className="fa-regular fa-rectangle-list"></i> {datas.data.label}
                                        </h5>
                                    </div>
                                    <div className="col-md-5 text-right">
                                        <button
                                            onClick={(e) => setShowConfirmation([true, datas.id])}
                                            type="button" className="btn-sm btn-danger"
                                        ><i className="fa-solid fa-trash"></i> </button>

                                        <button type="button" className="btn-sm btn-success" onClick={(e) => setWaPreview([true, "list", datas.id])}>
                                            <i className="fa-solid fa-eye"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body mt-0">
                                <AddNewListTemp
                                    setNodes={setNodes}
                                    setLoad={setLoad}
                                    load={load}
                                    onSave={saveListFormData}
                                    nodeId={datas.id}
                                    showError={showError}
                                    datas={datas.data.value} />
                            </div>
                        </div>
                    </Fragment>
                )
            }
        }
    }




    const CustomEdge = (event) => {
        let sourceX = event.sourceX
        let sourceY = event.sourceY
        let sourcePosition = event.sourcePosition
        let targetX = event.targetX
        let targetY = event.targetY
        let targetPosition = event.targetPosition


        let parentDetails = event.data.parent

        const [edgePath, labelX, labelY] = getBezierPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });

        const condSaveFun = (formDatas) => {
            setEdges(nds => {
                return nds.map(i => {
                    if (i.id == event.id) {
                        i.data.extra_cond = formDatas
                    }
                    return i
                })
            })
        }

        // const WaitTillBox = () => {
        //     const newRef = useRef();
        //     const [dateType, setDateType] = useState(event.data.schedule.dateType);
        //     let dt = ""
        //     if (event.data.schedule.date && event.data.schedule.date != "") {
        //         const newDt = event.data.schedule.date.split("-")
        //         dt = new Date(newDt[0], newDt[1], newDt[2], event.data.schedule.hours)
        //     } else {
        //         dt = new Date()
        //     }
        //     const { register: wait_reg, control: wait_control, handleSubmit: wait_handle } = useForm({
        //         defaultValues: {
        //             "schType": "wait_till",
        //             "dateType": event.data.schedule.dateType,
        //             "days": event.data.schedule.days,
        //             "hours": event.data.schedule.hours,
        //             "mins": event.data.schedule.mins,
        //             "date": dt
        //         }
        //     });


        //     const wait_set = (val, typo) => {
        //         setEdges(nds => {
        //             return nds.map(i => {
        //                 if (i.id == event.id) {
        //                     i.data.schedule.schType = "wait_till"
        //                     if (typo == "mins") {
        //                         i.data.schedule.mins = val
        //                     } else if (typo == "hours") {
        //                         i.data.schedule.hours = val
        //                     } else if (typo == "days") {
        //                         i.data.schedule.days = val
        //                     } else if (typo == "date") {
        //                         const dateObj = new Date(val);
        //                         const year = dateObj.getFullYear();
        //                         const month = String(dateObj.getMonth()).padStart(2, '0');
        //                         const day = String(dateObj.getDate()).padStart(2, '0');
        //                         const formattedDate = `${year}-${month}-${day}`;
        //                         i.data.schedule.date = formattedDate
        //                         i.data.schedule.hours = String(dateObj.getHours()).padStart(2, '0')
        //                     } else if (typo == "dateType") {
        //                         i.data.schedule.dateType = val
        //                         setDateType(val)
        //                     }
        //                 }
        //                 return i
        //             })
        //         })
        //     }

        //     const NewBox = () => {
        //         if (dateType != "") {
        //             if (dateType == "normal") {
        //                 return (
        //                     <div className="flex justify-around  bg-white_green">
        //                         <div className="flex flex-col">
        //                             <select {...wait_reg("days", { required: true, onChange: (e) => wait_set(e.target.value, "days") })} className='form-select'>
        //                                 {Array.from(Array(31).keys()).map(item => <option value={item}>{item}</option>)}
        //                             </select>
        //                             <span className="text-sm font-semibold text-slate-500">After Days </span>
        //                         </div>
        //                         <div className="flex flex-col">
        //                             <select {...wait_reg("hours", { required: true, onChange: (e) => wait_set(e.target.value, "hours") })} className='form-select'>
        //                                 {Array.from(Array(24).keys()).map(item => <option value={item}>{item}</option>)}
        //                             </select>
        //                             <span className="text-sm font-semibold text-slate-500">After HOURS </span>
        //                         </div>

        //                         {/* <div className="flex flex-col">
        //                             <select {...wait_reg("mins", { required: true, onChange: (e) => wait_set(e.target.value, "mins") })} className='form-select'>
        //                                 {Array.from(Array(60).keys()).map(item => <option value={item}>{item}</option>)}
        //                             </select>
        //                             <span className="text-sm font-semibold text-slate-500">After Mins </span>
        //                         </div> */}
        //                     </div>
        //                 )
        //             }
        //             else if (dateType == "date") {
        //                 return (
        //                     <div>
        //                         <Controller
        //                             name={'date'}
        //                             control={wait_control}
        //                             value={dt}
        //                             render={({ field }) => {
        //                                 return (<DatePicker
        //                                     className="form-control"
        //                                     selected={field.value}
        //                                     dateFormat="MMMM d, yyyy HH:mm"
        //                                     showTimeSelect
        //                                     timeFormat="HH"
        //                                     timeIntervals={60}
        //                                     minDate={new Date()}
        //                                     onChange={(date) => {
        //                                         field.onChange(date)
        //                                         wait_set(date, "date");
        //                                     }}
        //                                 />
        //                                 )
        //                             }}
        //                             rules={{ required: true }}
        //                         />
        //                     </div>
        //                 )
        //             }

        //             else if (dateType == "today") {
        //                 return (
        //                     <div className="flex justify-around  bg-white_green">

        //                         <div className="flex flex-col">
        //                             <select {...wait_reg("hours", { required: true, onChange: (e) => wait_set(e.target.value, "hours") })} className='form-select'>
        //                                 {Array.from(Array(24).keys()).map(item => <option value={item}>{item}</option>)}
        //                             </select>
        //                             <span className="text-sm font-semibold text-slate-500">HOURS </span>
        //                         </div>

        //                         <div className="flex flex-col">
        //                             <select {...wait_reg("mins", { required: true, onChange: (e) => wait_set(e.target.value, "mins") })} className='form-select'>
        //                                 <option value='0'>0</option>
        //                                 <option value='15'>15</option>
        //                                 <option value='30'>30</option>
        //                                 <option value='45'>45</option>
        //                             </select>
        //                             <span className="text-sm font-semibold text-slate-500">Mins </span>
        //                         </div>
        //                     </div>
        //                 )
        //             }
        //         }
        //     }

        //     return (
        //         <div className="card-body mt-0 ">
        //             <div className="contact_add_div">
        //                 <div className="mx-auto" ref={newRef}>
        //                     <input {...wait_reg("schType", { required: true })} type="hidden" value='wait_till' />
        //                     <select {...wait_reg("dateType", { required: true, onChange: (e) => wait_set(e.target.value, 'dateType') })} className='form-select color_date_bg'>
        //                         <option value="">Select Date Type</option>
        //                         <option value="normal">Normal</option>
        //                         <option value="today">Today</option>
        //                         <option value="date">Date</option>
        //                     </select>
        //                     <NewBox />
        //                 </div>
        //             </div>
        //         </div>
        //     )
        // }


        const BeforeBox = () => {
            const [delayType, setDelayType] = useState(event.data.schedule.delay_type);
            const [dateType, setDateType] = useState(event.data.schedule.day_type);
            let dt = new Date()

            if (event.data.schedule.delay_date && event.data.schedule.delay_date != "") {
                const newDt = event.data.schedule.delay_date.split("-")
                dt = new Date(newDt[0], newDt[1] - 1, newDt[2], event.data.schedule.delay_hours)
            }
            const newRef = useRef();

            const { register: wait_reg, control: wait_control, handleSubmit: wait_handle } = useForm({
                defaultValues: {
                    "delay_type": event.data.schedule.delay_type,
                    "day_type": event.data.schedule.day_type,
                    "delay_hours": event.data.schedule.delay_hours,
                    "delay_date": dt,
                }
            });

            const wait_set = (val, typo) => {
                setEdges(nds => {
                    return nds.map(i => {
                        if (i.id == event.id) {
                            if (typo == "delayType") {
                                i.data.schedule.delay_type = val
                                setDelayType(val)
                            } else if (typo == "dateType") {
                                i.data.schedule.day_type = val
                                setDateType(val)
                            } else if (typo == "date") {
                                const dateObj = new Date(val);
                                const year = dateObj.getFullYear();
                                const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                                const day = String(dateObj.getDate()).padStart(2, '0');
                                const formattedDate = `${year}-${month}-${day}`;
                                i.data.schedule.delay_date = formattedDate
                                i.data.schedule.hours = String(dateObj.getHours()).padStart(2, '0')
                            } else if (typo == "time") {
                                i.data.schedule.delay_hours = val
                            }
                        }
                        return i
                    })
                })
            }
            const NewBox = () => {
                if (dateType != "") {
                    if (dateType == "date") {
                        return (
                            <div>
                                <Controller
                                    name={'delay_date'}
                                    control={wait_control}
                                    value={dt}
                                    render={({ field }) => {
                                        return (<DatePicker
                                            className="form-control"
                                            selected={field.value}
                                            dateFormat="MMMM d, yyyy HH:mm"
                                            showTimeSelect
                                            timeFormat="HH"
                                            timeIntervals={60}
                                            minDate={new Date()}
                                            onChange={(date) => {
                                                field.onChange(date)
                                                wait_set(date, "date");
                                            }}
                                        />
                                        )
                                    }}
                                    rules={{ required: true }}
                                />
                            </div>
                        )
                    }

                    else if (dateType == "today") {
                        return (
                            <div>
                                <select {...wait_reg("delay_hours", { required: true, onChange: (e) => wait_set(e.target.value, "time") })} className='form-select'>
                                    {Array.from(Array(24).keys()).map(item => <option value={item}>{item}</option>)}
                                </select>
                                <span className="text-sm font-semibold text-slate-500">After HOURS </span>
                            </div>
                        )
                    }
                }

            }

            const DateBox = () => {
                if (delayType != "" && delayType != null) {
                    return (
                        <select {...wait_reg("day_type", { required: true, onChange: (e) => wait_set(e.target.value, 'dateType') })} className='form-select color_date_bg'>
                            <option value="">Select Date Type</option>
                            <option value="date">Date</option>
                            <option value="today">Today</option>
                        </select>
                    )
                }
            }

            return (
                <div className="card-body mt-0 ">
                    <div className="contact_add_div">
                        <div className="mx-auto" ref={newRef}>
                            <select {...wait_reg("delay_type", { required: true, onChange: (e) => wait_set(e.target.value, 'delayType') })} className='form-select color_date_bg'>
                                <option value="">Select Delay Type</option>
                                <option value="after">After</option>
                                <option value="before">Before</option>
                            </select>
                            <DateBox />
                            <NewBox />
                        </div>
                    </div>
                </div>
            )
        }


        const MiddleBox = () => {
            const [boxStatus, setBoxStatus] = useState(false)
            if (boxStatus == false) {
                return (
                    <div className="edge_button">
                        <button className="btn btn-sm text-whait" type='button' onClick={() => setBoxStatus(true)}>
                            <i className="fa-solid fa-plus"></i>
                        </button>
                    </div>
                )
            } else {
                return (
                    <div className="flex">
                        <div className="con_ashish">
                            <CondComponet2 allDatas={event} parent={parentDetails} condSave={condSaveFun} />
                        </div>
                        <div className="sedu_ashish">
                            <div className="card position-relative box_width">
                                <div className="card-header p-2 Condition_bg">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h6 className="mt-2 font-weight-bold  temp_text_color"> <i class="fa-solid fa-network-wired"></i> Wait Till</h6>
                                        </div>
                                    </div>
                                </div>
                                <WaitTillBox event={event} setEdges={setEdges} />
                            </div>
                            <div className="card position-relative box_width">
                                <div className="card-header p-2 Condition_bg">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h6 className="mt-2 font-weight-bold  temp_text_color"> <i class="fa-solid fa-network-wired"></i>Delay </h6>
                                        </div>
                                    </div>
                                </div>
                                <BeforeBox />
                            </div>
                        </div>
                    </div>
                )
            }
        }



        return (
            <Fragment>
                <BaseEdge path={edgePath} label={event.data.label} />
                <EdgeLabelRenderer>
                    <div
                        style={{
                            position: 'absolute',
                            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
                            fontSize: 12,
                            pointerEvents: 'all',
                        }}
                    >
                        <div className="edge_button">
                            <button className="btn btn-sm text-whait" type='button' onClick={(e) => onDelConn(event.id)}>
                                <i className="fa-solid fa-trash"></i>
                            </button>
                        </div>
                        <MiddleBox />
                    </div>
                </EdgeLabelRenderer>
            </Fragment>
        );
    }

    const nodeTypes = useMemo(() => ({ customnode: CustomNode }), [waInterQuery.data, waTempQuery.data, webhookQuery.data, funnelQuery.data])
    const edgeTypes = useMemo(() => ({ customedge: CustomEdge }), []);

    const onSave = useCallback((formDatas) => {
        if (rfInstance) {
            const flow = rfInstance.toObject();

            let flow_obj
            if (id) {
                flow_obj = {
                    flow: flow,
                    flow_name: formDatas.name,
                    phone_no_id: formDatas.phone_no_id,
                    flow_id: id,
                }
            } else {
                flow_obj = {
                    flow: flow,
                    flow_name: formDatas.name,
                    phone_no_id: formDatas.phone_no_id
                }
            }
            mutation.mutate({ flow_data: flow_obj })
        }
    }, [rfInstance]);



    const onConnect = useCallback((allparams) => {
        if (allparams.cond && allparams.datas) {
            const newEdge = {
                'source': allparams.source,
                'target': allparams.target,
                'sourceHandle': allparams.sourceHandle,
                'targetHandle': null,
                'id': `reactflow__edge-${allparams.source}-${allparams.target}-${Math.floor(Math.random() * 9999)}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "label": allparams.cond,
                    "parent": allparams.datas,
                    "custom_condition": "",
                    "schedule": {
                        "schType": '', 'days': "0", "dateType": "", "hours": '0', "mins": '0',
                        "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "extra": { 'srcHandle': allparams.sourceHandle, 'trgHandle': null, },
                    "extra_cond": {}
                }
            }
            console.log(newEdge)
            return setEdges((eds) => {
                eds.push(newEdge)
                return eds.map(i => {
                    // console.log(i)
                    return i
                })
            });
        }
    }, []);


    const OnPreview = () => {
        if (flowPreview) {
            if (rfInstance) {
                const flow = rfInstance.toObject();
                return (
                    <div className="confirmation-popup">
                        <div className="modal_as show-modal_as">
                            <div className="modal-content_as_side_pop p-0">
                                <div className="prv_scrl">
                                    <PreviewComp flow={flow} />
                                    <div className="btn_full_ashish mt-2"> <button className="btn-sm btn-danger" onClick={() => setFlowPreview(false)}> Close </button> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }
    };


    const addChannels = (channelVals) => {
        const parent_node = channelVals[2]
        const parent = channelVals[2].id
        const src_handle = channelVals[4]
        const cond = channelVals[3]
        const node_id = channelVals[1] + `-channel-${+Date.now()}`


        const apiDetail = parent_node.data.value.api
        const type = parent_node.data.value.type


        if (type == "on_message") {
            if (Object.keys(apiDetail.keywords).length == 0) {
                toast.error("Add atleast one Keyword in On Message Trigger")
                return;
            }
        } else if (type == "on_webhook") {
            if (apiDetail.webhookDetail == "" || apiDetail.phone_number_col == "") {
                toast.error("Add Webhook Detail")
                return;
            }
        } else if (type == "on_funnel") {
            if (apiDetail.funnelDetail == "" || apiDetail.phone_number_col == "") {
                toast.error("Add Funnel Detail first")
                return;
            }
        } else if (type == "on_attribute") {
            if (apiDetail.attributeDetails == "") {
                toast.error("Add Attribute Detail first")
                return;
            }
        }



        if (channelVals[1] == "button") {
            try {
                axios.post("https://tickmaker.io/api/get-int-template-by-id", {
                    "auth_key": wa_authKey,
                    "template_id": channelVals[0].template_id,
                    "interactive_type": "button",
                }, headers).then(resp => {
                    if (resp.data.status == "success") {
                        let api = {
                            'campaign_name': channelVals[0].title,
                            'sender': "dgffgh",
                            'whatsapp_var': JSON.stringify({}),
                            'template_id': channelVals[0].template_id,
                            "auth_key": wa_authKey,
                            "whatsapp_type": "interactive",
                            "interactive_type": "button",
                            "interactive_btn": JSON.stringify(resp.data.data)
                        }
                        const node1 = {
                            'id': node_id,
                            'type': 'customnode',
                            'position': getPos(parent_node),
                            'data': {
                                'label': channelVals[0].title,
                                'value': {
                                    'parent': parent,
                                    'type': "whatsapp",
                                    'api': api,
                                    'description': "",
                                    "extra": channelVals[0],
                                    "columns": parent_node.data.value.columns,
                                    "custom_rule": []
                                }
                            }
                        }
                        const edge1 = {
                            'source': parent,
                            'target': node_id,
                            'sourceHandle': src_handle,
                            'targetHandle': null,
                            'id': `reactflow__edge-${parent}-${node_id}`,
                            'animated': false,
                            'type': "customedge",
                            'data': {
                                "delay": { "days": 0, "hours": 0, "minutes": 0 },
                                "label": cond,
                                "parent": parent_node,
                                "custom_condition": "",
                                "schedule": {
                                    "schType": '', 'days': "0", "dateType": "", "hours": '0', "mins": '0', "delay_type": "",
                                    "day_type": "",
                                    "delay_hours": "00",
                                    "delay_date": ""
                                },
                                "extra": { 'srcHandle': src_handle, 'trgHandle': null, },
                                "extra_cond": {}
                            }
                        }
                        setNodes((nds) => nds.concat(node1));
                        setRefecther(!refecther)
                        setEdges((edg) => edg.concat(edge1));
                    }
                })
            } catch (error) {
                console.log(error)
            }
        } else if (channelVals[1] == "list") {
            try {
                axios.post("https://tickmaker.io/api/get-int-template-by-id", {
                    "auth_key": wa_authKey,
                    "template_id": channelVals[0].template_id,
                    "interactive_type": "list",
                }, headers).then(resp => {
                    if (resp.data.status == "success") {


                        console.log(resp.data)
                        let api = {
                            'campaign_name': channelVals[0].title,
                            'sender': "dgffgh",
                            'whatsapp_var': JSON.stringify({}),
                            'template_id': channelVals[0].template_id,
                            "auth_key": wa_authKey,
                            "whatsapp_type": "interactive",
                            "interactive_type": "list",
                            "interactive_btn": JSON.stringify(resp.data.data)
                        }
                        const node1 = {
                            'id': node_id,
                            'type': 'customnode',
                            'position': getPos(parent_node),
                            'data': {
                                'label': channelVals[0].title,
                                'value': {
                                    'parent': parent,
                                    'type': "whatsapp",
                                    'api': api,
                                    'description': "",
                                    "columns": parent_node.data.value.columns,
                                    "extra": channelVals[0],
                                    "custom_rule": []
                                }
                            }
                        }
                        const edge1 = {
                            'source': parent,
                            'target': node_id,
                            'sourceHandle': src_handle,
                            'targetHandle': null,
                            'id': `reactflow__edge-${parent}-${node_id}`,
                            'animated': false,
                            'type': "customedge",
                            'data': {
                                "delay": { "days": 0, "hours": 0, "minutes": 0 },
                                "label": cond,
                                "parent": parent_node,
                                "custom_condition": "",
                                "schedule": {
                                    "schType": '', 'days': "0", "dateType": "", "hours": '0', "mins": '0', "delay_type": "",
                                    "day_type": "",
                                    "delay_hours": "00",
                                    "delay_date": ""
                                },
                                "extra": { 'srcHandle': src_handle, 'trgHandle': null, },
                                "extra_cond": {}
                            }
                        }
                        setNodes((nds) => nds.concat(node1));
                        setEdges((edg) => edg.concat(edge1));

                    }
                })
            } catch (error) {
                console.log(error)
            }
        } else if (channelVals[1] == "template") {
            let api = {
                'campaign_name': channelVals[0].template_name,
                'sender': "dgffgh",
                'whatsapp_var': JSON.stringify({}),
                'template_id': channelVals[0].template_id,
                "auth_key": wa_authKey,
                "whatsapp_type": "template",
                "interactive_type": "button",
                "interactive_btn": ""
            }

            const node1 = {
                'id': node_id,
                'type': 'customnode',
                'position': getPos(parent_node),
                'data': {
                    'label': channelVals[0].template_name,
                    'value': {
                        'parent': parent,
                        'type': "whatsapp",
                        'api': api,
                        'description': "",
                        "extra": channelVals[0],
                        "custom_rule": [],
                        "columns": parent_node.data.value.columns
                    }
                }
            }
            const edge1 = {
                'source': parent,
                'target': node_id,
                'sourceHandle': src_handle,
                'targetHandle': null,
                'id': `reactflow__edge-${parent}-${node_id}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "label": cond,
                    "parent": parent_node,
                    "custom_condition": "",
                    "schedule": {
                        "schType": '', 'days': "0", "dateType": "", "hours": '0', "mins": '0', "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "extra": { 'srcHandle': src_handle, 'trgHandle': null, },
                    "extra_cond": {}
                }
            }
            setNodes((nds) => nds.concat(node1));

            setEdges((edg) => edg.concat(edge1));
        } else if (channelVals[1] == "wa_message") {
            const node1 = {
                'id': node_id,
                'type': 'customnode',
                'position': getPos(parent_node),
                'data': {
                    'label': "Send Message",
                    'value': {
                        'parent': parent,
                        'type': "wa_message",
                        'api': {},
                        'description': "",
                        "custom_rule": [],
                        "columns": parent_node.data.value.columns,
                        "extra": {}
                    }
                }
            }
            const edge1 = {
                'source': parent,
                'target': node_id,
                'sourceHandle': src_handle,
                'targetHandle': null,
                'id': `reactflow__edge-${parent}-${node_id}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "label": cond,
                    "parent": parent_node,
                    "custom_condition": "",
                    "schedule": {
                        "schType": '', "dateType": "", 'days': "0", "hours": '0', "mins": '0', "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "extra": { 'srcHandle': src_handle, 'trgHandle': null },
                    "extra_cond": {}
                }
            }
            setNodes((nds) => nds.concat(node1));
            setEdges((edg) => edg.concat(edge1));
        } else if (channelVals[1] == "agent_assign") {
            let api = {}
            const node1 = {
                'id': node_id,
                'type': 'customnode',
                'position': getPos(parent_node),
                'data': {
                    'label': "Agent Assign",
                    'value': {
                        'parent': parent,
                        'type': "agent_assign",
                        'api': api,
                        'description': "",
                        "custom_rule": [],
                        "columns": parent_node.data.value.columns,
                        "extra": {}
                    }
                }
            }
            const edge1 = {
                'source': parent,
                'target': node_id,
                'sourceHandle': src_handle,
                'targetHandle': null,
                'id': `reactflow__edge-${parent}-${node_id}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "label": cond,
                    "parent": parent_node,
                    "custom_condition": "",
                    "schedule": {
                        "schType": '', "dateType": "", 'days': "0", "hours": '0', "mins": '0', "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "extra": { 'srcHandle': src_handle, 'trgHandle': null },
                    "extra_cond": {}
                }
            }
            setNodes((nds) => nds.concat(node1));
            setEdges((edg) => edg.concat(edge1));
        } else if (channelVals[1] == "on_message") {
            const node1 = {
                'id': node_id,
                'type': 'customnode',
                'position': getPos(parent_node),
                'data': {
                    'label': "On Message",
                    'value': {
                        'parent': parent,
                        'type': "on_message",
                        'api': { "keywords": {} },
                        'description': "",
                        "custom_rule": [],
                        "columns": parent_node.data.value.columns,
                        "extra": {}
                    }
                }
            }
            const edge1 = {
                'source': parent,
                'target': node_id,
                'sourceHandle': src_handle,
                'targetHandle': null,
                'id': `reactflow__edge-${parent}-${node_id}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "schedule": {
                        "schType": '', "dateType": "", 'days': "0", "hours": '0', "mins": '0', "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "label": cond,
                    "parent": parent_node,
                    "custom_condition": "",
                    "extra": { 'srcHandle': src_handle, 'trgHandle': null },
                    "extra_cond": {}
                }
            }
            setNodes((nds) => nds.concat(node1));
            setEdges((edg) => edg.concat(edge1));
        } else if (channelVals[1] == "on_attribute") {
            const node1 = {
                'id': node_id,
                'type': 'customnode',
                'position': getPos(parent_node),
                'data': {
                    'label': "On Atrribute Change",
                    'value': {
                        'parent': parent,
                        'type': "on_attribute",
                        'api': {},
                        'description': "",
                        "custom_rule": [],
                        "columns": parent_node.data.value.columns,
                        "extra": {}
                    }
                }
            }
            const edge1 = {
                'source': parent,
                'target': node_id,
                'sourceHandle': src_handle,
                'targetHandle': null,
                'id': `reactflow__edge-${parent}-${node_id}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "schedule": {
                        "schType": '', "dateType": "", 'days': "0", "hours": '0', "mins": '0', "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "label": cond,
                    "parent": parent_node,
                    "custom_condition": "",
                    "extra": { 'srcHandle': src_handle, 'trgHandle': null },
                    "extra_cond": {}
                }
            }
            setNodes((nds) => nds.concat(node1));
            setEdges((edg) => edg.concat(edge1));
        } else if (channelVals[1] == "sms") {
            const node1 = {
                'id': node_id,
                'type': 'customnode',
                'position': getPos(parent_node),
                'data': {
                    'label': "SMS",
                    'value': {
                        'parent': parent,
                        'type': "sms",
                        'api': {
                            "campaign_name": "SMS",
                            "sender": "",
                            "auth_key": bssp_authKey,
                            "route": "",
                            "template_id": "",
                            "coding": "",
                            "pe_id": "",
                            "content": "",
                        },
                        "custom_rule": [],
                        'description': "",
                        "columns": parent_node.data.value.columns,
                        "extra": {}
                    }
                }
            }

            const edge1 = {
                'source': parent,
                'target': node_id,
                'sourceHandle': src_handle,
                'targetHandle': null,
                'id': `reactflow__edge-${parent}-${node_id}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "schedule": {
                        "schType": '', "dateType": "", 'days': "0", "hours": '0', "mins": '0', "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "label": cond,
                    "parent": parent_node,
                    "custom_condition": "",
                    "extra": { 'srcHandle': src_handle, 'trgHandle': null },
                    "extra_cond": {}
                }
            }
            setNodes((nds) => nds.concat(node1));
            setEdges((edg) => edg.concat(edge1));
        }

        else if (channelVals[1] == "mail") {
            const node1 = {
                'id': node_id,
                'type': 'customnode',
                'position': getPos(parent_node),
                'data': {
                    'label': "Mailer",
                    'value': {
                        'parent': parent,
                        'type': "mail",
                        'api': {
                            "campaign_name": "mailer",
                            "sender": "",
                            "auth_key": bssp_authKey,
                            "subject": "",
                            "sender_name": "",
                            "content": "",
                        },
                        "custom_rule": [],
                        'description': "",
                        "columns": parent_node.data.value.columns,
                        "extra": {}
                    }
                }
            }

            const edge1 = {
                'source': parent,
                'target': node_id,
                'sourceHandle': src_handle,
                'targetHandle': null,
                'id': `reactflow__edge-${parent}-${node_id}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "schedule": {
                        "schType": '', "dateType": "", 'days': "0", "hours": '0', "mins": '0', "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "label": cond,
                    "parent": parent_node,
                    "custom_condition": "",
                    "extra": { 'srcHandle': src_handle, 'trgHandle': null },
                    "extra_cond": {}
                }
            }
            setNodes((nds) => nds.concat(node1));
            setEdges((edg) => edg.concat(edge1));
        }

        else if (channelVals[1] == "voice") {
            const node1 = {
                'id': node_id,
                'type': 'customnode',
                'position': getPos(parent_node),
                'data': {
                    'label': "Voice",
                    'value': {
                        'parent': parent,
                        'type': "voice",
                        'api': {
                            "campaign_name": "Voice",
                            "sender": "",
                            "auth_key": bssp_authKey,
                            "route": "",
                            "voice_type": "",
                            "voice_duration": "",
                            "content": "",
                        },
                        "custom_rule": [],
                        'description': "",
                        "columns": parent_node.data.value.columns,
                        "extra": {}
                    }
                }
            }

            const edge1 = {
                'source': parent,
                'target': node_id,
                'sourceHandle': src_handle,
                'targetHandle': null,
                'id': `reactflow__edge-${parent}-${node_id}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "schedule": {
                        "schType": '', "dateType": "", 'days': "0", "hours": '0', "mins": '0', "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "label": cond,
                    "parent": parent_node,
                    "custom_condition": "",
                    "extra": { 'srcHandle': src_handle, 'trgHandle': null },
                    "extra_cond": {}
                }
            }
            setNodes((nds) => nds.concat(node1));
            setEdges((edg) => edg.concat(edge1));
        }

        else if (channelVals[1] == "save_funnel") {
            const node1 = {
                'id': node_id,
                'type': 'customnode',
                'position': getPos(parent_node),
                'data': {
                    'label': "Save Funnel",
                    'value': {
                        'parent': parent,
                        'type': "save_funnel",
                        'api': { "funnelDetail": "" },
                        'description': "",
                        "columns": [],
                        "custom_rule": [],
                        "extra": {}
                    }
                }
            }

            const edge1 = {
                'source': parent,
                'target': node_id,
                'sourceHandle': src_handle,
                'targetHandle': null,
                'id': `reactflow__edge-${parent}-${node_id}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "schedule": {
                        "schType": '', "dateType": "", 'days': "0", "hours": '0', "mins": '0', "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "label": cond,
                    "parent": parent_node,
                    "custom_condition": "",
                    "extra": { 'srcHandle': src_handle, 'trgHandle': null },
                    "extra_cond": {}
                }
            }


            setNodes((nds) => nds.concat(node1));
            setEdges((edg) => {
                console.log(edg.concat(edge1))
                return edg.concat(edge1)
            });
        }


        else if (channelVals[1] == "wait_till") {
            const node1 = {
                'id': node_id,
                'type': 'customnode',
                'position': getPos(parent_node),
                'data': {
                    'label': "wait_till",
                    'value': {
                        'parent': parent,
                        'type': "wait_till",
                        'api': {},
                        'description': "",
                        "custom_rule": [],
                        "extra": channelVals[0],
                        "columns": parent_node.data.value.columns
                    }
                }
            }
            const edge1 = {
                'source': parent,
                'target': node_id,
                'sourceHandle': src_handle,
                'targetHandle': null,
                'id': `reactflow__edge-${parent}-${node_id}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "label": cond,
                    "parent": parent_node,
                    "custom_condition": "",
                    "schedule": {
                        "schType": '', "dateType": "", 'days': "0", "hours": '0', "mins": '0', "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "extra": { 'srcHandle': src_handle, 'trgHandle': null },
                    "extra_cond": {}
                }
            }
            setNodes((nds) => nds.concat(node1));
            setEdges((edg) => edg.concat(edge1));
        }


        else if (channelVals[1] == "set_tag") {
            const node1 = {
                'id': node_id,
                'type': 'customnode',
                'position': getPos(parent_node),
                'data': {
                    'label': "Set Tags",
                    'value': {
                        'parent': parent,
                        'type': "set_tag",
                        'api': { "tags": [] },
                        'description': "",
                        "custom_rule": [],
                        "columns": parent_node.data.value.columns,
                        "extra": {}
                    }
                }
            }

            const edge1 = {
                'source': parent,
                'target': node_id,
                'sourceHandle': src_handle,
                'targetHandle': null,
                'id': `reactflow__edge-${parent}-${node_id}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "schedule": {
                        "schType": '', "dateType": "", 'days': "0", "hours": '0', "mins": '0', "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "label": cond,
                    "parent": parent_node,
                    "custom_condition": "",
                    "extra": { 'srcHandle': src_handle, 'trgHandle': null },
                    "extra_cond": {}
                }
            }
            setNodes((nds) => nds.concat(node1));
            setEdges((edg) => edg.concat(edge1));


        }


        else if (channelVals[1] == "call_api") {
            const node1 = {
                'id': node_id,
                'type': 'customnode',
                'position': getPos(parent_node),
                'data': {
                    'label': "API Call",
                    'value': {
                        'parent': parent,
                        'type': "call_api",
                        'api': {},
                        'description': "",
                        "custom_rule": [],
                        "columns": parent_node.data.value.columns,
                        "extra": {}
                    }
                }
            }
            const edge1 = {
                'source': parent,
                'target': node_id,
                'sourceHandle': src_handle,
                'targetHandle': null,
                'id': `reactflow__edge-${parent}-${node_id}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "schedule": {
                        "schType": '', "dateType": "", 'days': "0", "hours": '0', "mins": '0', "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "label": cond,
                    "parent": parent_node,
                    "custom_condition": "",
                    "extra": { 'srcHandle': src_handle, 'trgHandle': null },
                    "extra_cond": {}
                }
            }
            setNodes((nds) => nds.concat(node1));
            setEdges((edg) => edg.concat(edge1));
        }
        setRefecther(!refecther)

    }

    const addNewChannels = (channelVals) => {
        const type = channelVals[0]
        const parent_node = channelVals[1]
        const parent = channelVals[1].id
        const cond = channelVals[2]
        const src_handle = channelVals[3]
        const node_id = type + `-channel-${+Date.now()}`

        if (type == "button") {
            let api = {
                'campaign_name': "",
                'sender': "",
                'whatsapp_var': JSON.stringify({}),
                'template_id': "",
                "auth_key": wa_authKey,
                "whatsapp_type": "interactive",
                "interactive_type": "button",
                "interactive_btn": JSON.stringify([{ "title": "" }]),
                "ndsType": "new"
            }
            const node1 = {
                'id': node_id,
                'type': 'customnode',
                'position': getPos(parent_node),
                'data': {
                    'label': "create New Btn",
                    'value': {
                        'parent': parent,
                        'type': "pre_whatsapp",
                        'api': api,
                        'description': "",
                        "custom_rule": [],
                        "columns": parent_node.data.value.columns,
                        "extra": {}
                    }
                }
            }
            const edge1 = {
                'source': parent,
                'target': node_id,
                'sourceHandle': src_handle,
                'targetHandle': null,
                'id': `reactflow__edge-${parent}-${node_id}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "schedule": {
                        "schType": '', "dateType": "", 'days': "0", "hours": '0', "mins": '0', "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "label": cond,
                    "parent": parent_node,
                    "custom_condition": "",
                    "extra": { 'srcHandle': src_handle, 'trgHandle': null, },
                    "extra_cond": {}
                }
            }
            setNodes((nds) => nds.concat(node1));
            setEdges((edg) => edg.concat(edge1));
        } else if (type == "list") {
            let api = {
                'campaign_name': "",
                'sender': "",
                'whatsapp_var': JSON.stringify({}),
                'template_id': "",
                "auth_key": wa_authKey,
                "whatsapp_type": "interactive",
                "interactive_type": "list",
                "interactive_btn": JSON.stringify({}),
                "intListData": JSON.stringify([{ "title": "", "rows": [{ "row_title": "", "row_description": "" }] }]),
                "ndsType": "new"
            }

            const node1 = {
                'id': node_id,
                'type': 'customnode',
                'position': getPos(parent_node),
                'data': {
                    'label': "create New List",
                    'value': {
                        'parent': parent,
                        'type': "pre_whatsapp",
                        'api': api,
                        'description': "",
                        "custom_rule": [],
                        "columns": parent_node.data.value.columns,
                        "extra": {}
                    }
                }
            }
            const edge1 = {
                'source': parent,
                'target': node_id,
                'sourceHandle': src_handle,
                'targetHandle': null,
                'id': `reactflow__edge-${parent}-${node_id}`,
                'animated': false,
                'type': "customedge",
                'data': {
                    "delay": { "days": 0, "hours": 0, "minutes": 0 },
                    "schedule": {
                        "schType": '', "dateType": "", 'days': "0", "hours": '0', "mins": '0', "delay_type": "",
                        "day_type": "",
                        "delay_hours": "00",
                        "delay_date": ""
                    },
                    "label": cond,
                    "parent": parent_node,
                    "custom_condition": "",
                    "extra": { 'srcHandle': src_handle, 'trgHandle': null },
                    "extra_cond": {}
                }
            }
            setNodes((nds) => nds.concat(node1));
            setEdges((edg) => edg.concat(edge1));
        }
        setRefecther(!refecther)

    }
    const getPos = (parents) => {
        let new_pos = { x: "100", y: "100" }
        function addPos(nds, parents) {
            const children = nds.filter(item => item.data.value.parent == parents.id);
            const childCount = children.length;
            return (childCount + 1) * 300;
        }

        setNodes((nds) => {
            new_pos.x = parents.xPos + addPos(nds, parents)
            return nds
        })
        new_pos.y = parents.yPos
        return new_pos
    }

    const InertList = ({ node_id, cond, handles, type }) => {
        const [inputText, setInputText] = useState("");
        let inputHandler = (e) => {
            var lowerCase = e.target.value.toLowerCase();
            setInputText(lowerCase);
        };


        const filteredData = waInterQuery.data.data.interactive.filter((el) => {
            if (inputText === '') {
                return el;
            } else {
                return el.title.toLowerCase().includes(inputText)
            }
        })

        if (type == "button") {
            return (
                <ul className="as_new">
                    <input placeholder='Search Template' className='form-control' onChange={inputHandler} />
                    <li onClick={() => addNewChannels(["button", node_id, cond, handles])}>Create new Template</li>
                    {
                        filteredData.map((vals) => {
                            if (vals.int_type == "button") {
                                if (vals.is_variable == 0) {
                                    return (<li onClick={() => addChannels([vals, "button", node_id, cond, handles])}>{vals.title}</li>)
                                } else {
                                    return (<li onClick={() => addChannels([vals, "button", node_id, cond, handles])}>{vals.title} (Var)</li>)
                                }
                            }
                        })
                    }
                </ul>
            )
        } else if (type == "list") {
            return (
                <ul className="as_new">
                    <input placeholder='Search Template' className='form-control' onChange={inputHandler} />
                    <li onClick={() => addNewChannels(["list", node_id, cond, handles])}>Create new Template</li>
                    {
                        filteredData.map((vals) => {

                            if (vals.int_type == "list") {
                                if (vals.is_variable == 0) {
                                    return (<li onClick={() => addChannels([vals, "list", node_id, cond, handles])}>{vals.title}</li>)
                                } else {
                                    return (<li onClick={() => addChannels([vals, "list", node_id, cond, handles])}>{vals.title} (Var)</li>)
                                }
                            }

                        })
                    }
                </ul>
            )
        }


    }
    const TempList = ({ node_id, cond, handles }) => {
        const [inputText, setInputText] = useState("");
        let inputHandler = (e) => {
            var lowerCase = e.target.value.toLowerCase();
            setInputText(lowerCase);
        };

        const filteredData = waTempQuery.data.data.template.filter((el) => {
            if (inputText === '') {
                return el;
            } else {
                return el.template_name.toLowerCase().includes(inputText)
            }
        })

        return (
            <ul className="as_new">
                <input placeholder='Search Template' className='form-control' onChange={inputHandler} />
                {
                    filteredData.map((vals) => {
                        if (vals.is_variable == 0) {
                            return (<li onClick={() => addChannels([vals, "template", node_id, cond, handles])}>{vals.template_name}</li>)
                        } else {
                            return (<li onClick={() => addChannels([vals, "template", node_id, cond, handles])}>{vals.template_name} (Var)</li>)
                        }
                    })
                }
            </ul>
        )
    }

    const SaveFunnel = ({ node_id, cond, handles }) => {
        const [inputText, setInputText] = useState("");
        let inputHandler = (e) => {
            var lowerCase = e.target.value.toLowerCase();
            setInputText(lowerCase);
        };

        const filteredData = funnelQuery.data.data.segment_list.filter((el) => {
            if (inputText === '') {
                return el;
            } else {
                return el.segment_name.toLowerCase().includes(inputText)
            }
        })
        const col_list = funnelQuery.data.data.col_list
        return (
            <ul className="as_new">
                <input placeholder='search' onChange={inputHandler} />
                {
                    filteredData.map((vals) => (<li onClick={() => addChannels([vals, "save_funnel", node_id, cond, handles, col_list])}>{vals.segment_name}</li>))
                }
            </ul>
        )
    }


    const items_ul2 = (node_id, cond, handles) => {
        return (
            <Fragment>
                <Menu.Item>
                    <Fragment>
                        <Menu>
                            <Menu.Button as="li" className="w-full text-left flex items-center outline-none as_btn_new">
                                Send Interactive<i className="fa fa-angle-right ml-auto" aria-hidden="true"></i>
                            </Menu.Button>
                            <Menu.Items>
                                <InertList node_id={node_id} cond={cond} handles={handles} type="button" />
                            </Menu.Items>
                        </Menu>
                    </Fragment>
                </Menu.Item>
                <Menu.Item>
                    <Fragment>
                        <Menu>
                            <Menu.Button className="w-full text-left flex items-center outline-none as_btn_new">
                                Send Interactive List<i className="fa fa-angle-right ml-auto" aria-hidden="true"></i>
                            </Menu.Button>
                            <Menu.Items>
                                <InertList node_id={node_id} cond={cond} handles={handles} type="list" />
                            </Menu.Items>
                        </Menu>
                    </Fragment>
                </Menu.Item>

                <Menu.Item>
                    <Fragment>
                        <Menu>
                            <Menu.Button className="w-full text-left flex items-center outline-none as_btn_new">
                                Send Template <i className="fa fa-angle-right ml-auto" aria-hidden="true"></i>
                            </Menu.Button>
                            <Menu.Items>
                                <TempList node_id={node_id} cond={cond} handles={handles} />
                            </Menu.Items>
                        </Menu>
                    </Fragment>
                </Menu.Item>


                {/* 
                <Menu.Item>
                    <Fragment>
                        <Menu>
                            <Menu.Button className="w-full text-left flex items-center outline-none as_btn_new">
                                Funnel <i className="fa fa-angle-right ml-auto" aria-hidden="true"></i>
                            </Menu.Button>
                            <Menu.Items>
                                <SaveFunnel node_id={node_id} cond={cond} handles={handles} />
                            </Menu.Items>
                        </Menu>
                    </Fragment>
                </Menu.Item> */}

                <Menu.Item>
                    <li className="w-full text-left flex items-center outline-none as_btn_new" onClick={() => addChannels([[], "wa_message", node_id, cond, handles])}>Send Message</li>
                </Menu.Item>
                <Menu.Item>
                    <li className="w-full text-left flex items-center outline-none as_btn_new" onClick={() => addChannels([[], "agent_assign", node_id, cond, handles])}>Agent Assign</li>
                </Menu.Item>

                <Menu.Item>
                    <li className="w-full text-left flex items-center outline-none as_btn_new" onClick={() => addChannels([[], "set_tag", node_id, cond, handles])}>Set Tags</li>
                </Menu.Item>

                {/* ------------------------------------------------------------ */}
                <Menu.Item>
                    <li className="w-full text-left flex items-center outline-none as_btn_new" onClick={() => addChannels([[], "sms", node_id, cond, handles])}>Send SMS</li>
                </Menu.Item>
                <Menu.Item>
                    <li className="w-full text-left flex items-center outline-none as_btn_new" onClick={() => addChannels([[], "voice", node_id, cond, handles])}>Send Voice</li>
                </Menu.Item>
                <Menu.Item>
                    <li className="w-full text-left flex items-center outline-none as_btn_new" onClick={() => addChannels([[], "mail", node_id, cond, handles])}>Send Mail</li>
                </Menu.Item>
                <Menu.Item>
                    <li className="w-full text-left flex items-center outline-none as_btn_new" onClick={() => addChannels([[], "save_funnel", node_id, cond, handles])}>Save Funnel</li>
                </Menu.Item>

                {/* ------------------------------------------------------------ */}

                <Menu.Item>
                    <li className="w-full text-left flex items-center outline-none as_btn_new" onClick={() => addChannels([[], "on_message", node_id, cond, handles])}>On Message</li>
                </Menu.Item>
                <Menu.Item>
                    <li className="w-full text-left flex items-center outline-none as_btn_new" onClick={() => addChannels([[], "on_attribute", node_id, cond, handles])}>On Attribute Change</li>
                </Menu.Item>
            </Fragment>
        )
    }


    const errChecker = (error) => {
        if (error.response) {
            if (error.response.status == '401') noAuth()
        } else if (error.request) {
            console.error('Network Error:', error.request);
        } else {
            console.error('Error:', error.message);
        }
    }


    if (waTempQuery.isLoading || waInterQuery.isLoading || webhookQuery.isLoading || userDetailQuery.isLoading || emailSender.isLoading || phonebookQuery.isLoading) {
        return (<div className="spin_ashish"><Spinner /></div>)
    }
    if (waTempQuery.isError || waInterQuery.isError  || webhookQuery.isError || userDetailQuery.isError || emailSender.isError || phonebookQuery.isError) {

        if (userDetailQuery.error) {
            errChecker(userDetailQuery.error)
        }

        if (emailSender.error) {
            errChecker(userDetailQuery.error)
        }

        // if (tempQuery.error) {
        //     errChecker(userDetailQuery.error)
        // }
    }

    // || funnelQuery.isLoading  || funnelQuery.isError

    const new_Channel = (typo) => {
        let status = true;
        nodes.map(nds => {
            if (nds.data.value.parent == 0) {
                status = false
            }
        })
        if (status == true) {
            let node1 = {}
            if (typo == "on_attribute") {
                const col_obj = [
                    {
                        "type": "on_attribute",
                        "details": {},
                        "column": [
                            { "column_name": "full_name" },
                            { "column_name": "email" },
                            { "column_name": "contact" },
                            { "column_name": "address" },
                            { "column_name": "date_of_birth" },
                            { "column_name": "company_name" },
                            { "column_name": "company_email" },
                            { "column_name": "status" },
                            { "column_name": "lead_type" },
                            { "column_name": "city" },
                            { "column_name": "state" },
                            { "column_name": "country" },
                            { "column_name": "zip_code" },
                        ],
                    }
                ]
                node1 = {
                    'id': `on_attribute-channel-${+Date.now()}`,
                    'type': 'customnode',
                    'position': { "x": 100, "y": 100 },
                    'data': {
                        'label': "On Atrribute Change",
                        'value': { 'parent': 0, 'type': "on_attribute", 'api': { "attributeDetails": "" }, 'description': "", "columns": col_obj }
                    }
                }
            } else if (typo == "on_message") {
                const col_obj = [
                    {
                        "type": "on_message",
                        "details": {},
                        "column": [
                            // { "column_name": "profile_name" },
                            // { "column_name": "deliver_time" },
                            // { "column_name": "phone_number" },
                            { "column_name": "full_name" },
                            { "column_name": "email" },
                            { "column_name": "contact" },
                            { "column_name": "address" },
                            { "column_name": "date_of_birth" },
                            { "column_name": "company_name" },
                            { "column_name": "company_email" },
                            { "column_name": "status" },
                            { "column_name": "lead_type" },
                            { "column_name": "city" },
                            { "column_name": "state" },
                            { "column_name": "country" },
                            { "column_name": "zip_code" },
                        ],
                    }]
                node1 = {
                    'id': `on_message-channel-${+Date.now()}`,
                    'type': 'customnode',
                    'position': { "x": 100, "y": 100 },
                    'data': {
                        'label': "On Message",
                        'value': { 'parent': 0, 'type': "on_message", 'api': { "keywords": {} }, 'description': "", "columns": col_obj }
                    }
                }
            }


            else if (typo == "on_webhook") {
                node1 = {
                    'id': `on_webhook-channel-${+Date.now()}`,
                    'type': 'customnode',
                    'position': { "x": 100, "y": 100 },
                    'data': {
                        'label': "On Webhook",
                        'value': { 'parent': 0, 'type': "on_webhook", 'api': { "webhookDetail": "", "phone_number_col": "", Columns: [] }, 'description': "", "columns": {} }
                    }
                }
            } else if (typo == "on_funnel") {
                node1 = {
                    'id': `on_funnel-channel-${+Date.now()}`,
                    'type': 'customnode',
                    'position': { "x": 100, "y": 100 },
                    'data': {
                        'label': "Funnel",
                        'value': { 'parent': 0, 'type': "on_funnel", 'api': { "funnelDetail": "", "phone_number_col": "" }, 'description': "", "columns": {} }
                    }
                }
            }

            else if (typo == "phonebook") {
                node1 = {
                    'id': `phonebook-channel-${+Date.now()}`,
                    'type': 'customnode',
                    'position': { "x": 100, "y": 100 },
                    'data': {
                        'label': "Phonrbook",
                        'value': { 'parent': 0, 'type': "phonebook", 'api': { "phonebookDetail": "", "phone_number_col": "" }, 'description': "", "columns": {} }
                    }
                }
            }
            else if (typo == "on_new_funnel") {
                node1 = {
                    'id': `on_new_funnel-channel-${+Date.now()}`,
                    'type': 'customnode',
                    'position': { "x": 100, "y": 100 },
                    'data': {
                        'label': "Funnel",
                        'value': { 'parent': 0, 'type': "on_new_funnel", 'api': { "funnelDetail": "", "phone_number_col": "" }, 'description': "", "columns": {} }
                    }
                }
            }
            else if (typo == "on_edit_funnel") {
                node1 = {
                    'id': `on_edit_funnel-channel-${+Date.now()}`,
                    'type': 'customnode',
                    'position': { "x": 100, "y": 100 },
                    'data': {
                        'label': "Funnel",
                        'value': { 'parent': 0, 'type': "on_edit_funnel", 'api': { "funnelDetail": "", "phone_number_col": "", "SchDetail": {} }, 'description': "", "columns": {} }
                    }
                }
            }
            else if (typo == "agent_assign") {
                node1 = {
                    'id': `agent_assign-channel-${+Date.now()}`,
                    'type': 'customnode',
                    'position': { "x": 100, "y": 100 },
                    'data': {
                        'label': "Agent Assign",
                        'value': { 'parent': 0, 'type': "agent_assign", 'api': {}, 'description': "", "columns": {} }
                    }
                }
            }
            else if (typo == "on_spreedsheet") {
                node1 = {
                    'id': `on_spreedsheet-channel-${+Date.now()}`,
                    'type': 'customnode',
                    'position': { "x": 100, "y": 100 },
                    'data': {
                        'label': "on_spreedsheet",
                        'value': { 'parent': 0, 'type': "on_spreedsheet", 'api': {}, 'description': "", "columns": {} }
                    }
                }
            }
            else if (typo == "google_sheet") {
                node1 = {
                    'id': `google_sheet-channel-${+Date.now()}`,
                    'type': 'customnode',
                    'position': { "x": 100, "y": 100 },
                    'data': {
                        'label': "Google Sheet",
                        'value': { 'parent': 0, 'type': "google_sheet", 'api': {}, 'description': "", "columns": {} }
                    }
                }
            }



            else if (typo == "all_attrtibute") {
                const col_obj = [
                    {
                        "type": "on_attribute",
                        "details": {},
                        "column": [
                            { "column_name": "full_name" },
                            { "column_name": "email" },
                            { "column_name": "contact" },
                            { "column_name": "address" },
                            { "column_name": "date_of_birth" },
                            { "column_name": "company_name" },
                            { "column_name": "company_email" },
                            { "column_name": "status" },
                            { "column_name": "lead_type" },
                            { "column_name": "city" },
                            { "column_name": "state" },
                            { "column_name": "country" },
                            { "column_name": "zip_code" },
                        ],
                    }
                ]
                node1 = {
                    'id': `all_attrtibute-channel-${+Date.now()}`,
                    'type': 'customnode',
                    'position': { "x": 100, "y": 100 },
                    'data': {
                        'label': "On Atrribute Change",
                        'value': {
                            'parent': 0, 'type': "all_attrtibute", 'api': {
                                "attributeDetails": "",
                                "dripCamp": "1",
                                "agents": []
                            }, 'description': "", "columns": col_obj
                        }
                    }
                }
            }
            setNodes((nds) => nds.concat(node1));
        } else {
            toast.error("You can Add only one trigger")
        }
        setRefecther(!refecther)
    };

    const errorShow = (err) => {
        toast.error(err)
    }


    const WaPreview = ({ waPreData }) => {
        const Pre = () => {
            if (waPreData[1] == "button") {
                return <img src={ButtonImg} alt="Whatsapp List Preview" />
            } else if (waPreData[1] == "list") {
                return <img src={ListImg} alt="Whatsapp List Preview" />
            }
        }

        if (waPreData[0]) {
            return (
                <div className="confirmation-popup">
                    <div className="modal_as show-modal_as">
                        <div className="modal-content_as_side_pop">
                            <Pre />
                            <div className="text-center">
                                <button className="btn-sm btn-danger" onClick={() => setWaPreview([false, "", ""])}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    return (
        <Fragment>
            <HeaderNav2 new_Channel={new_Channel} noAuth={noAuth} />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    {showConfirmation[0] && (
                        <div className="confirmation-popup">
                            <div className="modal_as show-modal_as">
                                <div className="modal-content_as">
                                    <p>Are you sure you want to delete this element?</p>
                                    <div className="text-center">
                                        <button className="btn btn-success mr-2" onClick={() => onDelNode(showConfirmation[1])}>Yes</button>
                                        <button className="btn-sm btn-danger" onClick={() => setShowConfirmation([false, ""])}>No</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <WaPreview waPreData={waPreview} />
                    <OnPreview />
                    <ReactFlowProvider>
                        <div className="dndflow w-full" style={{ height: '100vh' }} ref={reactFlowWrapper}>
                            <div className="reactflow-wrapper h-full"  >
                                <div className="flex flex-row-reverse zindex_as">
                                    <div className="bot_name_bg">
                                        <SavingForm
                                            flowDetail={flowDetail}
                                            phone_details={waTempQuery.data.data.phone_details}
                                            errorShow={errorShow}
                                            onSave={onSave}
                                        />
                                        <button type="button" className="btn_as_my_wew ml-2" onClick={(e) => setFlowPreview(true)}> Preview </button>
                                    </div>
                                </div>
                                <ReactFlow
                                    nodes={nodes}
                                    edges={edges}
                                    onNodesChange={onNodesChange}
                                    onEdgesChange={onEdgesChange}
                                    onInit={setRfInstance}
                                    nodeTypes={nodeTypes}
                                    edgeTypes={edgeTypes}
                                    onConnect={onConnect}
                                    defaultViewport={defaultViewport}
                                >
                                    <Background variant="cross" gap={20} size={4} color='#c4c4c4' style={{ 'backgroundColor': '#fff' }} />
                                    <Controls position="bottom-left" ></Controls>
                                </ReactFlow>
                            </div>
                        </div>
                        <ToastContainer />
                    </ReactFlowProvider>
                </div>
            </div>
        </Fragment>
    );
}